// src/components/Card/ContentAddCard.jsx

import React, { useRef, useState } from 'react';
import { Button, message } from 'antd';
import { ClearOutlined, CheckOutlined } from '@ant-design/icons';
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import cardClient from "../../client/CardClient"; // Импорт CardClient
import { useSelector } from 'react-redux'; // Импорт useSelector для получения deckId из Redux
import useTranslation from '../../hooks/useTranslation';

const ContentAddCard = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    // Создаём рефы для редакторов
    const questionEditorRef = useRef(null);
    const answerEditorRef = useRef(null);

    // Получение выбранной колоды из Redux Store
    const selectedDeck = useSelector((state) => state.deck.selectedDeck);
    const deckId = selectedDeck ? selectedDeck.deckId : null;

    const handleClearForm = () => {
        // Вызываем метод clear для каждого редактора через рефы
        if (questionEditorRef.current) {
            questionEditorRef.current.clear();
        }
        if (answerEditorRef.current) {
            answerEditorRef.current.clear();
        }
    };

    const handleSave = async () => {
        // Получаем содержимое редакторов через рефы
        const questionContent = questionEditorRef.current ? questionEditorRef.current.getContent() : '';
        const answerContent = answerEditorRef.current ? answerEditorRef.current.getContent() : '';

        // Валидация данных
        if (!deckId) {
            message.error(t('deck.noneSelected'));
            return;
        }

        if (!questionContent.trim()) {
            message.error(t('card.questionRequired'));
            return;
        }

        if (!answerContent.trim()) {
            message.error(t('card.answerRequired'));
            return;
        }

        // Формирование данных для отправки
        const cardData = {
            deckId,
            question: questionContent,
            answer: answerContent,
            // Добавьте дополнительные поля, если необходимо
        };

        console.log('Submitting card data:', cardData); // Логирование для отладки

        setLoading(true);
        try {
            await cardClient.createCard(cardData);
            message.success(t('card.added'));
            // Сброс формы после успешного добавления
            handleClearForm();
        } catch (error) {
            console.error('Error saving the card:', error);
            // Обработка ошибок
            message.error(t('card.addFailed', { message: error.message }));
        } finally {
            setLoading(false);
        }
    };


    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '16px',
            width: '100%',
            margin: '0 auto'
        }}>
            {/* Блок для вопроса и ответа */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
            }}>
                <RichTextEditor
                    ref={questionEditorRef} // Привязываем реф
                    placeholder={t('card.questionPlaceholder')}
                    minHeight={50}
                />
                <RichTextEditor
                    ref={answerEditorRef} // Привязываем реф
                    placeholder={t('card.answerPlaceholder')}
                    minHeight={150}
                />

                {/* Uncomment the line below if you need a read-only editor */}
                {/* <RichTextEditor readOnly={true} /> */}
            </div>

            {/* Кнопки управления формой */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px' }}>
                <Button icon={<ClearOutlined />} onClick={handleClearForm}>
                    {t('common.cancel')}
                </Button>
                <Button type="primary" icon={<CheckOutlined />} loading={loading} onClick={handleSave}>
                    {t('common.save')}
                </Button>
            </div>
        </div>
    );
};

export default ContentAddCard;
